import { UploadService, ProcessItem } from './../../../services/upload.service';
import { bbDeepCopy } from 'app/shared/utils/bbDeepCopy.util';
import { TranslateService } from '@ngx-translate/core';
import { OverlayService, NoticeDefinition } from './../../../services/overlay.service';
import { catchError } from 'rxjs/operators';
import { SapiService } from './../../../services/sapi.service';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { of } from 'rxjs';
import { TrimChange } from '../bb-frame-select/bb-frame-select.component';

@Component({
	selector: 'bb-trim',
	templateUrl: './bb-trim.component.html',
	styleUrls: ['./bb-trim.component.scss']
})

export class BbTrimComponent {
	@Input() mediaclip: Mediaclip;

	@Output() onSave: EventEmitter<Mediaclip> = new EventEmitter();
	@Output() onError: EventEmitter<string> = new EventEmitter();
	@Output() onCancel: EventEmitter<void> = new EventEmitter();

	fromTime: number;
	toTime: number;
	isTrimmed: boolean;

	processing: boolean;

	constructor(
		private overlayService: OverlayService,
		private translateService: TranslateService,
		private uploadService: UploadService,
		private sapiService: SapiService
	) {
	}

	onTrimChanged(trimChange: TrimChange) {
		this.fromTime = trimChange.fromTime;
		this.toTime = trimChange.toTime;
		this.isTrimmed = trimChange.isTrimmed;
	}

	onSaveClick(asNew: boolean) {
		this.processing = true;
		if (asNew) {
			const clipCopy = bbDeepCopy(this.mediaclip);
			'id date import importSource importUrl length sourceid thumbnails youtubeImportId timelines exports subtitles transcript assets audiotracks isEmpty'
				.split(' ')
				.forEach(prop => {
					delete clipCopy[prop];
				});
			clipCopy.title = `${clipCopy.title ? clipCopy.title + ' ' : ''}[trimmed]`;
			this.sapiService.create('mediaclip', clipCopy).subscribe((newClip) => {
				this.processTrim(newClip);
			});
			return;
		}

		// replace
		this.processTrim(this.mediaclip);
	}

	onCancelClick() {
		this.onCancel.emit();
	}

	private onTrimError(res: any) {
		const notice: NoticeDefinition = {
			icon: 'warning',
			title: this.translateService.instant('ERROR'),
			type: 'error',
			contents: res?.body ? res?.body : 'Unknown error while trimming.'
		};
		this.overlayService.createNotice(notice);
	}

	private processTrim(targetClip: Mediaclip) {
		if (!targetClip) {
			this.processing = false;
			return;
		}

		const processItem: ProcessItem = {
			type: 'ProcessItem',
			status: 'new',
			sourceClip: this.mediaclip,
			targetClip,
			id: targetClip.id
		};
		this.uploadService.onProcess(processItem);

		const postParams: any = {
			type: 'trim',
			from: this.fromTime,
			duration: this.toTime - this.fromTime,
			targetClipId: targetClip.id
		};
		this.sapiService
			.postUrl(`/mediaclip/${this.mediaclip.id}/process`, postParams)
			.pipe(
				catchError((error) => {
					this.processing = false;
					return of(error);
				})
			).subscribe((response) => {
				this.processing = false;
				if (response?.error) {
					this.onTrimError(response?.error);
					this.onError.emit(response?.error);
				} else {
					this.onSave.emit(targetClip);
				}
			});
	}
}
